import { Typography, IconButton, Icon, Box, CircularProgress, Stack } from '@ace-clublabs/shared-component-library';
import { numberHelper } from '../utils/numberHelper';
import { ProductType } from '../application/models/NewJoinSessionData';

interface IAddOn {
  onDelete?: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  showPrice?: boolean;
  price: number | string;
  discountedPrice?: number | string;
  isSelected: boolean;
  text: string;
  icon: string;
  type: ProductType | 'associate' | 'family-upgrade';
  hideAddDeleteIcon?: boolean;
}

export const AddOn = ({
  onDelete,
  onEdit,
  showPrice,
  isSelected,
  text,
  price,
  discountedPrice,
  icon,
  onAdd,
  type,
  hideAddDeleteIcon,
}: IAddOn) => {
  let priceContent: any = price;
  if (showPrice === undefined) {
    showPrice = true;
  }
  if (typeof price == 'number') {
    priceContent = numberHelper.formatMoney(price);
  } else if (!price) {
    priceContent = (
      <div style={{ marginTop: 8 }}>
        <CircularProgress variant="indeterminate" size={24} />
      </div>
    );
  }

  const showEditButton = isSelected && onEdit;
  const containerClassName = `add-${type}-container ${isSelected ? 'benefit-selected' : 'add-benefit-container'}`;
  const priceClassName = `${type}-price`;
  const editClassName = `edit-${type}`;
  const addClassName = `add-${type}`;
  const removeClassName = `remove-${type}`;

  const isAssociate = type === 'associate';

  const productAdded = (type === ProductType.ERS || type === ProductType.RV) && isSelected;

  const priceContainer = () => {
    return discountedPrice != null && discountedPrice != 0 ? (
      <>
        <Typography
          variant="b1Regular"
          className={priceClassName}
          sx={{ color: '#9E9E9E', textDecorationLine: 'line-through', marginRight: '8px' }}
        >
          {priceContent}
        </Typography>
        <Typography variant="b1Regular">{discountedPrice}</Typography>
      </>
    ) : (
      <Typography variant="b1Regular" className={priceClassName}>
        {priceContent}
      </Typography>
    );
  };

  return (
    <Stack className={containerClassName} direction="row">
      <Stack className="add-benefit" direction="row" justifyContent="flex-start" alignItems="flex-start" gap="8px">
        <Box sx={{ fontSize: '1.5rem' }} className={'addon-icon'}>
          {isSelected ? (
            <Icon iconName="circle-check-solid" color="primary" className="check-icon" />
          ) : (
            <Icon iconName={icon as any} color="primary"></Icon>
          )}
        </Box>
        <Typography data-di-mask={isAssociate ? 'true' : 'false'} className="add-on-text qm-mask" variant="b1Regular">
          {productAdded ? 'Added' : `${text}`}
        </Typography>
      </Stack>
      <Stack className="add-benefit-details" direction="row" justifyContent="flex-end" alignItems="center" gap="0.5rem">
        {showPrice ? priceContainer() : <></>}
        {showEditButton ? (
          <IconButton
            aria-label={editClassName}
            onClick={onEdit}
            className={editClassName}
            sx={{ padding: '0 !important', height: '24px', width: '24px' }}
          >
            <Icon iconName="pen-regular" />
          </IconButton>
        ) : (
          <></>
        )}

        {hideAddDeleteIcon ? (
          <></>
        ) : isSelected ? (
          <IconButton
            aria-label={removeClassName}
            onClick={onDelete}
            className={removeClassName}
            sx={{ padding: '0 !important', height: '24px', width: '24px' }}
          >
            <Icon iconName="circle-x-regular" />
          </IconButton>
        ) : (
          <IconButton
            aria-label={addClassName}
            sx={{ fontSize: '1rem', padding: '0 !important', height: '24px', width: '24px' }}
            onClick={onAdd}
            className={addClassName}
          >
            <Icon iconName="plus-regular" />
          </IconButton>
        )}
      </Stack>
    </Stack>
  );
};
